import { makeStyles } from 'tss-react/mui';

export const usePaymentTabStyles = makeStyles()(theme => ({
  paymentTabRoot: {
    borderRadius: 16,
    [theme.breakpoints.down('xs')]: {
      minHeight: 0,
      height: 28,
      borderRadius: 8,
    },
  },
}));
